<template>
  <v-layout
    row
    pb-2>
    <v-flex
      xs12
      md8
      offset-md2
      xl6
      offset-xl3>
      <v-card class="card--flex-toolbar">
        <app-secondary-toolbar
          :title="productData.name"
          :back-link="'productList'" />
        <v-divider />
        <v-card-text>
          <v-form>
            <v-subheader class="primary--text sub-header">
              Omschrijving
            </v-subheader>
            <v-container>
              <v-layout
                row
                wrap>
                <v-flex xs12>
                  <v-select
                    v-model="productData.productCategory"
                    :items="categoryList"
                    item-text="title[0].text"
                    item-value="_id"
                    label="Categorie"
                    box />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.name"
                    label="Naam"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.reference"
                    label="Referentie"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.brand"
                    label="Merk"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.type"
                    label="Type"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  v-for="(locale, key) in productData.description"
                  :key="key"
                  xs12
                  lg6>
                  <v-textarea
                    v-model="productData.description[key].text"
                    :label="`Omschrijving ${locale.locale.substring(0,2).toUpperCase()}`"
                    auto-grow
                    box
                    @input="doChange" />
                </v-flex>
              </v-layout>
            </v-container>
            <v-subheader class="primary--text sub-header">
              Gegevens
            </v-subheader>
            <v-container>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.price"
                    type="number"
                    label="Prijs"
                    suffix="EUR"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.yearOfConstruction"
                    type="number"
                    label="Bouwjaar"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.hours"
                    type="number"
                    label="Uren"
                    suffix="u"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.capacity"
                    type="number"
                    label="Capaciteit"
                    suffix="kg"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.liftAltitude"
                    type="number"
                    label="Hefhoogte"
                    suffix="cm"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.driveThroughAltitude"
                    type="number"
                    label="Doorrijhoogte"
                    suffix="cm"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.weight"
                    type="number"
                    label="Gewicht"
                    suffix="kg"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.tracks"
                    type="number"
                    label="Rupsen"
                    suffix="%"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.engineBrand"
                    type="text"
                    label="Merk motor"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.cylinderCount"
                    type="number"
                    label="Aantal cylinders"
                    box
                    @input="doChange" />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  xl3>
                  <v-text-field
                    v-model="productData.bucketCount"
                    type="number"
                    label="Aantal bakken"
                    box
                    @input="doChange" />
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  md3>
                  <p>Zijschuiver</p>
                  <v-btn-toggle v-model="productData.sideSlider">
                    <v-btn
                      flat
                      @click.stop="doChange">
                      <v-icon>check</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      @click.stop="doChange">
                      <v-icon>not_interested</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
                <v-flex
                  xs12
                  md3>
                  <p>Joystick-bediening</p>
                  <v-btn-toggle v-model="productData.joystickControl">
                    <v-btn
                      flat
                      @click.stop="doChange">
                      <v-icon>check</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      @click.stop="doChange">
                      <v-icon>not_interested</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
                <v-flex
                  xs12
                  md3>
                  <p>Extra leiding</p>
                  <v-btn-toggle v-model="productData.extraTubing">
                    <v-btn
                      flat
                      @click.stop="doChange">
                      <v-icon>check</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      @click.stop="doChange">
                      <v-icon>not_interested</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
                <v-flex
                  xs12
                  md3>
                  <p>Verkocht</p>
                  <v-btn-toggle v-model="productData.sold">
                    <v-btn
                      flat
                      @click.stop="doChange">
                      <v-icon>check</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      @click.stop="doChange">
                      <v-icon>not_interested</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-container>
            <v-subheader class="primary--text sub-header">
              Afbeeldingen
            </v-subheader>
            <v-container>
              <v-layout
                row
                wrap>
                <v-flex
                  v-for="(media, key) in productData.media"
                  :key="key"
                  xs6
                  sm4
                  md3
                  xl2>
                  <v-card>
                    <v-card-media
                      :src="media.location"
                      height="200px" />
                    <v-btn
                      absolute
                      dark
                      small
                      fab
                      bottom
                      right
                      color="red"
                      @click="deleteImage(key)">
                      <v-icon>delete_forever</v-icon>
                    </v-btn>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <vue-dropzone
                    id="dropzone"
                    ref="myVueDropzone"
                    :options="dropzoneOptions"
                    @vdropzone-success="imageUploaded" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-dialog
            v-if="id !== 'new'"
            v-model="deleteDialog"
            width="500">
            <v-btn
              slot="activator"
              color="red"
              flat>
              Product verwijderen
            </v-btn>

            <v-card>
              <v-card-title
                class="headline"
                primary-title>
                Product verwijderen
              </v-card-title>
              <v-card-text>
                Ben je zeker dat je "{{ productData.name }}" wil verwijderen?
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="secondary"
                  flat
                  @click="deleteDialog=false">Annuleren</v-btn>
                <v-btn
                  color="red"
                  flat
                  @click="deleteProduct">Verwijderen</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <app-save-button
            :save-state="saveState"
            @click.native="saveProduct" />
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "@/axios-auth";
import appSecondaryToolbar from "@/components/TheSecondaryToolbar";
import appSaveButton from "@/components/SaveButton";
import vue2Dropzone from "vue2-dropzone";

import { mapGetters } from "vuex";

import config from "../../config";

export default {
  name: "ProductDetail",
  components: {
    appSecondaryToolbar,
    appSaveButton,
    vueDropzone: vue2Dropzone
  },
  props: {
    id: {
      type: String,
      required: false,
      default: null
    },
    categoryId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    saving: false,
    changesMade: false,
    unsaved: true,
    deleteDialog: false,
    categoryList: [],
    productData: {
      description: [
        { locale: "de-de", text: "" },
        { locale: "fr-be", text: "" },
        { locale: "en-gb", text: "" },
        { locale: "nl-be", text: "" }
      ],
      media: [],
      newMedia: []
    }
  }),
  computed: {
    ...mapGetters({
      userToken: "user/getToken"
    }),
    saveState() {
      if (this.saving === true) return "saving";
      if (!this.changesMade && (this.productData.productCategory === this.categoryId)) {
        if (this.unsaved === true) return "unchanged";
        return "saved";
      }
      return "changed";
    },
    dropzoneOptions() {
      const options = {
        url: `${config.OKF_API_ROOT}/upload/${this.id}`,
        thumbnailWidth: 150,
        maxFilesize: 4,
        acceptedFiles: "image/jpeg",
        uploadMultiple: false,
        headers: { "x-auth": this.userToken }
      };

      return options;
    }
  },
  created() {
    if (this.id !== "new") this.fetchProduct();
    else this.productData.productCategory = this.categoryId;
    this.fetchCategories();
  },
  methods: {
    doChange() {
      this.changesMade = true;
    },
    imageUploaded(file, response) {
      this.$refs.myVueDropzone.removeFile(file);
      this.productData.media.push(response);
      if (Object.prototype.hasOwnProperty.call(this.productData, "newMedia")) this.productData.newMedia.push(response._id);
      else this.productData.newMedia = [response._id];
    },
    fetchCategories() {
      axios.get("/categories", { headers: { "x-locale": "nl-be" } })
        .then((response) => {
          this.categoryList = response.data.categories;
        });
    },
    fetchProduct() {
      axios.get(`/products/${this.id}`, { headers: { "x-locale": "all" } })
        .then((response) => {
          this.productData = response.data.product;
        });
    },
    saveProduct() {
      this.saving = true;
      if (this.id === "new") {
        this.productData.media = this.productData.newMedia;
        axios.post("/products", this.productData, { headers: { "x-auth": this.userToken } })
          .then((response) => {
            this.productData = response.data;
            this.unsaved = false;
            this.saving = false;
            this.changesMade = false;
            this.$router.replace({ name: "productDetail", params: { id: response.data._id, categoryId: response.data.productCategory } });
            this.$refs.myVueDropzone.setOption("url", `${config.OKF_API_ROOT}/upload/${response.data._id}`);
          }).catch(() => {
            this.saving = false;
          });
      } else {
        axios.put(`/products/${this.id}`, this.productData, { headers: { "x-auth": this.userToken } })
          .then((response) => {
            this.productData = response.data.product;
            this.unsaved = false;
            this.saving = false;
            this.changesMade = false;
            this.$router.replace({ name: "productDetail", params: { id: response.data.product._id, categoryId: response.data.product.productCategory } });
          }).catch(() => {
            this.saving = false;
          });
      }
    },
    deleteProduct() {
      axios.delete(`/products/${this.id}`, { headers: { "x-auth": this.userToken } })
        .then(() => {
          this.$router.push({ name: "productList" });
        });
    },
    deleteImage(key) {
      axios.delete(`/media/${this.productData.media[key].id}`, { headers: { "x-auth": this.userToken } })
        .then(() => {
          this.productData.media.splice(key, 1);
          if (Object.prototype.hasOwnProperty.call(this.productData, "newMedia")) {
            const index = this.productData.newMedia.indexOf(this.productData.media[key].id);
            if (index > -1) this.productData.newMedia.splice(index, 1);
          }
        });
    }
  }
};
</script>
